const namespace = 'sidebar'

export const OPEN_SIDEBAR = `${namespace}/OPEN_SIDEBAR`
export const CLOSE_SIDEBAR = `${namespace}/CLOSE_SIDEBAR`
export const COLLAPSE_SIDEBAR = `${namespace}/COLLAPSE_SIDEBAR`
export const UNCOLLAPSE_SIDEBAR = `${namespace}/UNCOLLAPSE_SIDEBAR`
